import { getApiClient, initializeApiClient } from "../../apiService";

export const UpdateExperienceSummary = async (
  tE_PreviousExperienceSummaryId,
  projectName,
  briefDescriptionOfProject,
  yearOfImplementation,
  durationOfImplementationInMonths,
  countryWhereProjectWasImplemented,
  governorateRegion,
  nameOfProjectDonor,
  amountOfSupportReceived,
  contactPersonFromDonorOrganizationName,
  contactInformationEmailPhone,

  tE_TeamMembersPreviousExperiencePartnershipsId
) => {
  await initializeApiClient();
  const apiClient = await getApiClient();
  const response = await apiClient.post(
    `/api/TE_PreviousExperienceSummary/UpdateTE_PreviousExperienceSummaryData`,
    {
      tE_PreviousExperienceSummaryId: tE_PreviousExperienceSummaryId,
      projectName: projectName,
      briefDescriptionOfProject: briefDescriptionOfProject,
      yearOfImplementation: yearOfImplementation,
      durationOfImplementationInMonths: durationOfImplementationInMonths,
      countryWhereProjectWasImplemented: countryWhereProjectWasImplemented,
      governorateRegion: governorateRegion,
      nameOfProjectDonor: nameOfProjectDonor,
      amountOfSupportReceived: amountOfSupportReceived,
      contactPersonFromDonorOrganizationName:
        contactPersonFromDonorOrganizationName,
      contactInformationEmailPhone: contactInformationEmailPhone,
      tE_TeamMembersPreviousExperiencePartnershipsId:
        tE_TeamMembersPreviousExperiencePartnershipsId,
    }
  );

  return response;
};

export default UpdateExperienceSummary;
